export default __webpack_public_path__ + "static/media/_list_icon.77fb00a2.svg";